import * as React from "react";
import PropTypes from "prop-types";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TSFBoop from "../../Assests/tsfLogo.jpg";
import * as Style from "./style";
import AdminHeader from "./AdminHeader";
import { ListItem } from "@mui/material";
import Navbar from "../Navbar/Navbar";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DashboardTemplate = ({ children }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Style.AdminBg>
      <Box sx={{ display: "flex" }}>
        <AdminHeader
          handleDrawerOpen={handleDrawerOpen}
          position="fixed"
          open={open}
        />

        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            <Box sx={{ img: { maxWidth: "80px" } }}>
              <ListItem>
                <Box
                  component="img"
                  alt="Logo"
                  src={TSFBoop}
                  link="true"
                  className="WebsiteLogo"
                  sx={{ width: "60%" }}
                />
              </ListItem>
            </Box>
            <IconButton onClick={handleDrawerClose}>
              {theme?.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />

          <Navbar open={open} />
        </Drawer>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            mt: 8,
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Style.AdminBg>
  );
};
export default DashboardTemplate;

DashboardTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};
